import { PresetVisibility } from '@aibees/shared/definition';
import { useMemo } from 'react';

interface ItemWithVisibility {
  visibility?: string | PresetVisibility | null;
}

export function usePresetVisibilityCounts<T extends ItemWithVisibility>(
  items: T[]
): {
  [PresetVisibility.ALL]: number;
  [PresetVisibility.PRIVATE]: number;
  [PresetVisibility.INTERNAL]: number;
} {
  return useMemo(
    () => ({
      [PresetVisibility.ALL]: items?.length || 0,
      [PresetVisibility.PRIVATE]:
        items?.filter((x) => x.visibility === PresetVisibility.PRIVATE)
          .length || 0,
      [PresetVisibility.INTERNAL]:
        items?.filter((x) => x.visibility === PresetVisibility.INTERNAL)
          .length || 0,
    }),
    [items]
  );
}
